import React from "react";
import PageShell from "../common/page_shell";
import Experience from "../inner/experience/experience";
import data from "../data/biodata.json";

const ExperiencePage = () => {
  return (
    <PageShell>
      <Experience exp={data?.details?.histories || {}} />
    </PageShell>
  );
};

export default ExperiencePage;
